import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop=""
    >
      <div
        className={`relative overflow-hidden rounded-lg bg-background-100 transition-transform duration-300 group-hover:-translate-y-1 ${
          isLarge ? 'aspect-[3/4]' : 'aspect-[2/3]'
        }`}
      >
        <img
          src={comic.coverUrl}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 韩国漫画在线观看`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-background-50 text-xs leading-relaxed line-clamp-3">
            {comic.description}
          </p>
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full">
            连载中
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-secondary-500 text-background-50 text-xs px-2 py-0.5 rounded-full">
            已完结
          </span>
        )}
        <span className="absolute top-2 right-2 bg-foreground-900/60 text-background-50 text-xs px-1.5 py-0.5 rounded flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          {comic.rating}
        </span>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-foreground-400">|</span>
          <span className="text-xs text-foreground-500">{comic.category}</span>
        </div>
        {!isLarge && (
          <p className="text-xs text-foreground-600 mt-1.5 line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        )}
      </div>
    </Link>
  );
}